import type { MonthCoverageFill } from "../utils";

export type SegmentPlay = {
  changed: boolean;
  from: number;
  origin: "left" | "right";
};

// Reviewed fills have no animation of their own, so they never join the sequence.
const ANIMATED_FILLS: MonthCoverageFill[] = ["full", "half-start", "half-end"];

// Acknowledging a gap only restyles it; the coverage underneath is the same, so it is not a change.
const COVERAGE_SHAPE: Record<MonthCoverageFill, MonthCoverageFill> = {
  none: "none",
  "half-start": "half-start",
  "half-end": "half-end",
  full: "full",
  reviewed: "none",
  "half-start-reviewed": "half-start",
  "half-end-reviewed": "half-end",
};

// Only segments whose coverage changed animate, continuing from where the previous fill ended.
export const planSegments = (fills: MonthCoverageFill[], previous: MonthCoverageFill[] | null): SegmentPlay[] =>
  fills.map((fill, index) => {
    const before = previous?.[index] === undefined ? undefined : COVERAGE_SHAPE[previous[index]];
    const continuesFromHalf = fill === "full" && (before === "half-start" || before === "half-end");

    return {
      changed: ANIMATED_FILLS.includes(fill) && (previous === null || before !== COVERAGE_SHAPE[fill]),
      from: continuesFromHalf ? 0.5 : 0,
      origin: fill === "full" && before === "half-end" ? "right" : "left",
    };
  });
